export default __webpack_public_path__ + "static/media/mural.0aa239de.jpg";